<template>
    <div>
        <form class="mt-4">

            <div class="row mt-3 pl-6">
                <div class="col-md-4 col-lg-4 col-12">
                    <div class="new-user-form__single-input-wrapper">
                        <label for="address" class="label">Address</label>
                        <input type="text" class="input" v-model="location.address" placeholder="-- Enter address --" />
                    </div>
                </div>

                <div class="col-md-4 col-lg-4 col-12">
                    <div class="new-user-form__single-input-wrapper">
                        <label for="mname" class="label">Country</label>
                        <el-select v-model="selectedCountry" value-key="isoCode" placeholder="-- Select Country --">
                            <el-option v-for="country in countries" :key="country.isoCode" :label="country.name"
                                :value="country">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="col-md-4 col-lg-4 col-12">
                    <div class="new-user-form__single-input-wrapper">
                        <label for="gender" class="label">State</label>
                        <el-select v-model="selectedState" value-key="isoCode" placeholder="-- Select State --">
                            <el-option v-for="state in states" :key="state.isoCode" :label="state.name" :value="state">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="col-md-4 col-lg-4 col-12">
                    <div class="new-user-form__single-input-wrapper">
                        <label for="lname" class="label">City</label>
                        <el-select v-model="selectedCity" placeholder="-- Select City --">
                            <el-option v-for="city in cities" :key="city.name" :label="city.name" :value="city.name">
                            </el-option>
                        </el-select>
                    </div>
                </div>

            </div>

            <div class="next-submit flex justify-end mt-4">
                <button @click="goToVerify"
                     :class="['py-2 px-4 text-[16px] font-semibold text-[#10233E] transition-all duration-300', buttonClass]">
                    Next
                </button>
            </div>

        </form>
    </div>
</template>

<script>
import { Country, State, City } from "country-state-city";

export default {
    
    data() {
        return {
            location: {
                address: "",
                country: "",
                state: "",
                city: "",
            },
            countries: [],
            states: [],
            cities: [],
            selectedCountry: null,
            selectedState: null,
            selectedCity: null,
            
        };
    },

    mounted() {
        this.countries = Country.getAllCountries();
    },

    watch: {
        selectedCountry(newVal) {
            if (!newVal) {
                this.states = []
                this.cities = []
                return
            }

            this.states = State.getStatesOfCountry(newVal.isoCode)
            this.location.country = newVal.name
        },

        selectedState(newVal) {
            if (!newVal) {
                this.cities = []
                this.selectedCity = null
                return
            }
            this.cities = City.getCitiesOfState(
                this.selectedCountry.isoCode,
                newVal.isoCode
            )
            // Save actual name
            this.location.state = newVal.name
        },
        selectedCity(newVal) {
            if (!newVal) return
            this.location.city = newVal
        },
    },

       computed: {
        buttonClass() {
            return this.isFormValid
                ? 'opacity-100 cursor-pointer hover:scale-105'
                : 'opacity-50 cursor-not-allowed';
        },

        isFormValid() {
            return (
                this.location.country.trim() &&
                this.location.state.trim() &&
                this.location.city.trim() &&
                this.location.address.trim() 
            );
        }
    },

    methods: { 
        goToVerify(e) {
            e.preventDefault();
            if (this.isFormValid) {
                this.$emit('openVerify', this.location)
            } else {
                this.generateToast("Form is invalid, cannot proceed.", "error");
                return;
            }
        },
        
    }

}
</script>

<style scoped>

/* label {
    font-weight: 700;
    font-size: 14px;
    color: #383F51;
}

input {
    background-color: #FBFCFE;
    border: 1px solid #DAE8F6;
    border-radius: 2px;
    padding: 2% 0 2% 2%;
    width: 100%;
} */

.next-submit>button {
    background-color: #FCC210;
    border-radius: 2px;
    /* opacity: 0.5;
    cursor: not-allowed; */
}


</style>
